import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

import { getAppPaths } from "@app/routes/app-paths";
import { useFlag } from "@unleash/proxy-client-react";
import { Database, FileDown, Folders, FolderTree, Monitor, ShoppingBasket, TableProperties, User } from "lucide-react";

import { MenuLink } from "./menu-link";
import { MenuLinkHome } from "./menu-link-home";
import { MenuProject } from "./menu-project";
import { Container, Nav, TopNav } from "./styles";

export type MenuProps = {
  hasSystemMessage?: boolean;
};

export const Menu = ({ hasSystemMessage }: MenuProps) => {
  const { pathname } = useLocation();
  const appPaths = useMemo(() => {
    return getAppPaths();
  }, []);
  const showCmaLink = useFlag("cma-demo");
  const isTestDriveCurate = pathname.includes("test-drive-curate");
  const showViewPipeline = useFlag("view_pipeline");
  const showViewUpload = useFlag("view_upload");
  const showSsdiDataset = useFlag("ssdi_dataset");
  const isSandboxUser = useFlag("sandbox_access");
  const showDownloadsCenter = useFlag("downloads_center");
  const { pId: projectId } = useParams();

  return (
    <Container hasSystemMessage={hasSystemMessage}>
      <Nav>
        <MenuLinkHome />
        {!isTestDriveCurate && !isSandboxUser && (
          <TopNav>
            {!projectId ? (
              <>
                <MenuLink url={`/${appPaths.projects}`} title="All Projects" testLabel={"project-page"}>
                  <Folders size="lg" />
                </MenuLink>
                {showViewPipeline && (
                  <MenuLink url={`/${appPaths.pipelines}`} title="Datasets" testLabel={"pipeline-page"}>
                    <FolderTree size="lg" />
                  </MenuLink>
                )}
                {showViewUpload && (
                  <MenuLink url={`/${appPaths.upload}`} title="Bulk Data Upload" testLabel={"pipeline-page"}>
                    <TableProperties size="lg" />
                  </MenuLink>
                )}
                {showSsdiDataset && (
                  <MenuLink url={`/${appPaths.ssdi}`} title="Data Management" testLabel={"ssdi-page"}>
                    <Database size="lg" />
                  </MenuLink>
                )}
                {showDownloadsCenter && (
                  <MenuLink url={`/${appPaths.downloadsCenter}`} title="Results" testLabel={"results-page"}>
                    <FileDown size="lg" />
                  </MenuLink>
                )}
              </>
            ) : (
              <MenuProject projectId={projectId} />
            )}
          </TopNav>
        )}
        {isSandboxUser && (
          <TopNav>
            <MenuLink url={`/${appPaths.cmaDemo}/terms`} title="Demo" testLabel={"demo-link"}>
              <Monitor size="lg" />
            </MenuLink>
          </TopNav>
        )}
        <div>
          {!showCmaLink && (
            <>
              <MenuLink url={`/${appPaths.account}`} title="Account" testLabel={"account-link"}>
                <User size="lg" />
              </MenuLink>
              <MenuLink url={""} title="" testLabel={""}></MenuLink>
            </>
          )}
          {showCmaLink && !isSandboxUser && (
            <MenuLink url={`/${appPaths.cmaDemo}`} title="CMA Demo" testLabel={"cma-demo-link"}>
              <ShoppingBasket size="lg" />
            </MenuLink>
          )}
        </div>
      </Nav>
    </Container>
  );
};
